import { render, staticRenderFns } from "./create-username-password-component.vue?vue&type=template&id=279a2f40&"
import script from "./create-username-password-component.vue?vue&type=script&lang=js&"
export * from "./create-username-password-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "create-username-password-component.vue"
export default component.exports